import { axiosInstance } from "api/axios.instance"

class CompetitorsService {
	static COMPETITORS = "competitors"

	async getCompetitors() {
		return axiosInstance.get(`${CompetitorsService.COMPETITORS}/`)
	}

	async getModelNumbers() {
		return axiosInstance.get(`${CompetitorsService.COMPETITORS}/model_numbers/`)
	}

	async addCompetitor(name: string) {
		return axiosInstance.post(`${CompetitorsService.COMPETITORS}/`, { name })
	}

	async editCompetitor(id: number, name: string) {
		return axiosInstance.patch(`${CompetitorsService.COMPETITORS}/${id}/`, { name })
	}

	async deleteCompetitor(id: number) {
		return axiosInstance.delete(`${CompetitorsService.COMPETITORS}/${id}/`)
	}

	async editCompetitorModelNumbers(competitorId: number, modelNumbers: string[], stevensId: number) {
		return axiosInstance.patch(`${CompetitorsService.COMPETITORS}/${competitorId}/set_model_numbers/`, {
			competitor_model_numbers: modelNumbers,
			stevens_model_number_id: stevensId,
		})
	}
}

export default new CompetitorsService()
